import React, { useEffect, useState, useRef, Fragment } from 'react';
const comparisonRows = [{
  without: '100+ horas/año buscando resúmenes dispersos',
  with: 'Todo organizado por materia en un solo lugar'
}, {
  without: 'Estudiás de cero cada parcial',
  with: '6 tomos con resúmenes listos para repasar'
}, {
  without: 'Finales que se acumulan sin saber por dónde empezar',
  with: 'Guía de estudio por materia + mnemotecnias'
}, {
  without: 'Casos clínicos que te llevan horas',
  with: 'Tomos de Guardia y Medicina Interna resueltos'
}, {
  without: 'Anatomía y farmacología en 5 libros distintos',
  with: 'Resúmenes filtrados en un solo material'
}, {
  without: 'Materias recursadas por falta de método',
  with: 'Sistema de estudio Active Recall + Anki'
}, {
  without: 'Sin saber qué te van a tomar en el final',
  with: 'Checklist con los 50 temas más frecuentes'
}, {
  without: 'Carrera desorganizada de principio a fin',
  with: 'Sistema de Gestión Académica™ desde primer año'
}, {
  without: 'Sin planillas editables para organizarte',
  with: '7 editables premium listos para personalizar'
}];
const TIMER_KEY = 'medico_en_proceso_countdown_end';
const DURATION_MS = 24 * 60 * 60 * 1000;
function getEndTime(): number {
  if (typeof window === 'undefined') return Date.now() + DURATION_MS;
  const stored = localStorage.getItem(TIMER_KEY);
  if (stored) {
    const end = parseInt(stored, 10);
    if (end > Date.now()) return end;
  }
  const end = Date.now() + DURATION_MS;
  localStorage.setItem(TIMER_KEY, String(end));
  return end;
}
function getTimeLeft(endTime: number) {
  const diff = Math.max(0, endTime - Date.now());
  return {
    hours: Math.floor(diff / (1000 * 60 * 60)),
    minutes: Math.floor(diff % (1000 * 60 * 60) / (1000 * 60)),
    seconds: Math.floor(diff % (1000 * 60) / 1000)
  };
}
export function DarkCTA() {
  const [endTime] = useState<number>(() => getEndTime());
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(endTime));
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(getTimeLeft(endTime)), 1000);
    return () => clearInterval(timer);
  }, [endTime]);
  const pad = (n: number) => String(n).padStart(2, '0');
  const trackFb = (name: string, value: number) => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: name,
        content_category: 'Médico en Proceso',
        value,
        currency: 'ARS'
      });
    }
  };
  const handleScroll = () => {
    if (!scrollRef.current) return;
    const {
      scrollLeft,
      offsetWidth
    } = scrollRef.current;
    setActiveIndex(Math.round(scrollLeft / offsetWidth));
  };
  const scrollTo = (index: number) => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollTo({
      left: index * scrollRef.current.offsetWidth,
      behavior: 'smooth'
    });
    setActiveIndex(index);
  };
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-16 sm:py-20 text-gray-900 text-base leading-6" style={{
    background: 'linear-gradient(180deg, rgb(240,249,255) 0%, rgb(255,255,255) 100%)'
  }} data-id="element-114">
      <div className="mx-auto max-w-4xl text-center" data-id="element-115">
        {/* Brand */}
        <div className="mb-8 sm:text-3xl font-black tracking-[3px] text-[18px]" style={{
        color: '#0284c7'
      }} data-id="element-116">
          🩺 MÉDICO EN PROCESO™
        </div>

        {/* Headlines */}
        <h2 className="text-xl sm:text-3xl font-bold text-gray-900 m-0 mb-3" data-id="element-117">
          El próximo parcial podés volver a improvisar.
        </h2>
        <p className="text-xl sm:text-3xl font-black m-0 mb-10" style={{
        color: '#0284c7'
      }} data-id="element-118">
          O podés entrar con todo resuelto desde hoy.
        </p>

        {/* Comparison */}
        <div className="mx-auto max-w-2xl mb-12" data-id="element-119">
          <div className="text-center font-bold text-gray-900 rounded-t-2xl px-4 py-4 border border-b-0 border-gray-200 text-sm" style={{
          backgroundColor: 'rgb(243,244,246)'
        }} data-id="element-120">
            ¿Cuánto cuesta NO tenerlo?
          </div>

          <div className="grid grid-cols-2 border border-b-0 border-gray-200" style={{
          backgroundColor: 'rgb(243,244,246)'
        }} data-id="element-121">
            <div className="text-center font-bold text-gray-500 px-4 py-3 text-xs sm:text-sm" data-id="element-122">
              SIN MÉDICO EN PROCESO
            </div>
            <div className="text-center font-bold border-l border-gray-200 px-4 py-3 text-xs sm:text-sm" style={{
            color: '#0284c7'
          }} data-id="element-123">
              CON MÉDICO EN PROCESO
            </div>
          </div>

          {/* MOBILE carousel */}
          <div className="block sm:hidden border border-gray-200 rounded-b-2xl overflow-hidden" data-id="element-124">
            <div ref={scrollRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide" style={{
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }} data-id="element-125">
              {comparisonRows.map((row, i) => <div key={i} className="flex shrink-0 w-full snap-center grid grid-cols-2" data-id="element-126">
                  <div className="px-4 py-4 text-xs text-gray-500 flex items-center" data-id="element-127">
                    <span className="text-red-400 mr-1.5 text-base" data-id="element-128">✗</span>
                    {row.without}
                  </div>
                  <div className="px-4 py-4 text-xs font-bold text-gray-900 border-l border-gray-100 flex items-center" style={{
                backgroundColor: 'rgba(14,165,233,0.05)'
              }} data-id="element-129">
                    <span className="mr-1.5 text-base" style={{
                  color: '#0ea5e9'
                }} data-id="element-130">
                      ✓
                    </span>
                    {row.with}
                  </div>
                </div>)}
            </div>

            <div className="flex flex-col items-center gap-2 py-3 border-t border-gray-100" style={{
            backgroundColor: 'rgb(249,250,251)'
          }} data-id="element-131">
              <div className="flex gap-1.5" data-id="element-132">
                {comparisonRows.map((_, i) => <button key={i} onClick={() => scrollTo(i)} className="rounded-full transition-all" style={{
                width: i === activeIndex ? '18px' : '7px',
                height: '7px',
                backgroundColor: i === activeIndex ? 'rgb(2,132,199)' : 'rgb(209,213,219)'
              }} data-id="element-133" />)}
              </div>
              <span className="text-[10px] text-gray-400" data-id="element-134">
                {activeIndex + 1} de {comparisonRows.length}
              </span>
            </div>
          </div>

          {/* DESKTOP table */}
          <div className="hidden sm:block border border-gray-200 rounded-b-2xl overflow-hidden" data-id="element-135">
            {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-136">
                <div className="px-4 py-3 text-sm text-gray-500" data-id="element-137">
                  ✗ {row.without}
                </div>
                <div className="px-4 py-3 text-sm font-bold text-gray-900 border-l border-gray-100" style={{
              backgroundColor: 'rgba(14,165,233,0.05)'
            }} data-id="element-138">
                  ✓ {row.with}
                </div>
              </div>)}
          </div>
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-139">
          <p className="font-bold text-gray-900 m-0 mb-4" data-id="element-140">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className="flex items-center justify-center gap-0" data-id="element-141">
            {[{
            value: timeLeft.hours,
            label: 'hs'
          }, {
            value: timeLeft.minutes,
            label: 'min'
          }, {
            value: timeLeft.seconds,
            label: 'seg'
          }].map((item, i) => <Fragment key={item.label} data-id="element-142">
                <div className="flex flex-col items-center" data-id="element-143">
                  <span className="text-5xl sm:text-7xl font-black tabular-nums" style={{
                color: 'rgb(255,68,68)'
              }} data-id="element-144">
                    {pad(item.value)}
                  </span>
                  <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-145">
                    {item.label}
                  </span>
                </div>
                {i < 2 && <span className="mb-4 text-5xl sm:text-7xl font-black" style={{
              color: 'rgb(255,68,68)'
            }} data-id="element-146">
                    :
                  </span>}
              </Fragment>)}
          </div>
        </div>

        <p className="text-sm text-gray-600 m-0 mb-12" data-id="element-147">
          Después sube{' '}
          <span className="font-bold text-red-500" data-id="element-148">$15.000 ARS</span> y no
          vuelve.
        </p>

        {/* Three Pricing Cards */}
        <div className="mx-auto max-w-3xl mb-10 grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-149">
          {/* Nivel 1 */}
          <div className="flex flex-col rounded-xl p-5 border border-gray-200 shadow-sm" style={{
          backgroundColor: 'rgb(255,255,255)'
        }} data-id="element-150">
            <div className="mb-2 text-2xl" data-id="element-151">✅</div>
            <h3 className="text-sm font-black text-gray-900 m-0 mb-1" data-id="element-152">
              MÉDICO EN PROCESO™
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-153">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-154">
              <p className="text-xs text-gray-400 line-through m-0 mb-1" data-id="element-155">
                $58.990 ARS
              </p>
              <p className="text-xl font-black text-gray-900 m-0 mb-4" data-id="element-156">
                $22.950 ARS
              </p>
              <a href="https://www.bibliotecaprofesional.com/cart/48331899568298:1" onClick={() => trackFb('Médico en Proceso Nivel 1', 22950)} className="block text-white text-center text-xs font-black rounded-lg py-3 no-underline hover:opacity-90 transition-opacity" style={{
              backgroundColor: '#0284c7'
            }} data-id="element-157">
                → ELEGIR ESTE
              </a>
            </div>
          </div>

          {/* Nivel 2 */}
          <div className="flex flex-col rounded-xl p-5 border border-gray-200 shadow-sm" style={{
          backgroundColor: 'rgb(255,255,255)'
        }} data-id="element-158">
            <div className="mb-2 text-2xl" data-id="element-159">⭐</div>
            <h3 className="text-sm font-black m-0 mb-1" style={{
            color: '#0284c7'
          }} data-id="element-160">
              CARRERA ORGANIZADA™
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-161">
              Todo lo anterior + 2 Tomos clínicos
            </p>
            <div className="mt-auto" data-id="element-162">
              <p className="text-xs text-gray-400 line-through m-0 mb-1" data-id="element-163">
                $102.990 ARS
              </p>
              <p className="text-xl font-black m-0 mb-4" style={{
              color: '#0284c7'
            }} data-id="element-164">
                $29.950 ARS
              </p>
              <a href="https://www.bibliotecaprofesional.com/cart/48331900715178:1" onClick={() => trackFb('Sistema Carrera Organizada', 29950)} className="block text-white text-center text-xs font-black rounded-lg py-3 no-underline hover:opacity-90 transition-opacity" style={{
              backgroundColor: '#0284c7'
            }} data-id="element-165">
                → ELEGIR ESTE
              </a>
            </div>
          </div>

          {/* Nivel 3 */}
          <div className="flex flex-col rounded-xl p-5 shadow-sm" style={{
          backgroundColor: 'rgb(240,249,255)',
          border: '2px solid #0284c7',
          boxShadow: 'rgba(14,165,233,0.15) 0px 0px 30px 0px'
        }} data-id="element-166">
            <div className="mb-2 text-2xl" data-id="element-167">🏆</div>
            <h3 className="text-sm font-black m-0 mb-1" style={{
            color: '#0284c7'
          }} data-id="element-168">
              GESTIÓN ACADÉMICA™
            </h3>
            <p className="text-xs text-gray-400 m-0 mb-1" data-id="element-169">La más completa</p>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-170">
              Todo lo anterior + 7 editables premium
            </p>
            <div className="mt-auto" data-id="element-171">
              <p className="text-xs text-gray-400 line-through m-0 mb-1" data-id="element-172">
                $149.990 ARS
              </p>
              <p className="text-2xl font-black m-0 mb-4" style={{
              color: '#0284c7'
            }} data-id="element-173">
                $34.950 ARS
              </p>
              <a href="https://www.bibliotecaprofesional.com/cart/48331901698218:1" onClick={() => trackFb('Sistema Gestión Académica', 34950)} className="block text-white text-center text-xs font-black rounded-lg py-3 no-underline hover:opacity-90 transition-opacity" style={{
              backgroundColor: '#0284c7'
            }} data-id="element-174">
                → ELEGIR ESTE
              </a>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-600" data-id="element-175">
          <span data-id="element-176">🔒 Pago 100% seguro</span>
          <span data-id="element-177">⚡ Acceso en 5 minutos</span>
          <span data-id="element-178">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-179">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </div>
      </div>
    </section>;
}